import { useEffect, useState, type ComponentProps } from 'react';
import Scritto from '@scritto/react';

export interface RollingValueProps {
  value: string;
  transition?: ComponentProps<typeof Scritto>['transition'];
}

/**
 * A value whose glyphs roll when it changes: Scritto, once mounted, and the plain text before that.
 *
 * Scritto measures its glyphs in a layout effect, which the server cannot run and warns about with a
 * full component stack on every render. Nothing can roll before the first change, and the first change
 * can only come after mount, so the server and the first client pass show the same plain text and the
 * swap is invisible.
 */
export function RollingValue({ value, transition }: RollingValueProps) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted ? <Scritto value={value} transition={transition} /> : <>{value}</>;
}
